import cookie from 'amkit3-modules/utils/cookie';

const VOLUME_KEY = 'amkit3-v-player-profile-volume';

export const getVolume = () => {
  let volume = Number(cookie.get(VOLUME_KEY));
  if (isNaN(volume)) {
    volume = 1;
  }
  return volume;
};

export const setVolume = (value) => {
  cookie.set(VOLUME_KEY, value, {
    path: '/',
    expires: new Date(new Date().valueOf() + 365 * 24 * 60 * 60 * 1000),
  });
};

const DEFINITION_KEY = 'v-player-profile-definition';

export const getDigitalDefinition = (definition) => {
  return definition === 'yuanhua' ? '4000' : definition;
};

export const getDefinition = () => {
  const defaultDefinition = '1300';
  const maxDefaultDefinition = 'yuanhua';
  const selectedDefinition = localStorage.getItem(DEFINITION_KEY);
  if (!selectedDefinition) {
    return defaultDefinition;
  } else {
    const selectedDigitalDefinition = getDigitalDefinition(selectedDefinition);
    const maxDefaultDigitalDefinition =
      getDigitalDefinition(maxDefaultDefinition);
    if (
      Number(selectedDigitalDefinition) > Number(maxDefaultDigitalDefinition)
    ) {
      return maxDefaultDefinition;
    }
    return selectedDefinition;
  }
};

export const setDefinition = (value) => {
  // cookie.set(DEFINITION_KEY, value, {
  //   path: '/',
  //   expires: new Date(new Date().valueOf() + 365 * 24 * 60 * 60 * 1000)
  // })
  localStorage.setItem(DEFINITION_KEY, value);
  window.pullStreamFrom = 1
};

export default {
  getVolume,
  setVolume,
  getDigitalDefinition,
  getDefinition,
  setDefinition,
};
